import type { Selector } from '@reduxjs/toolkit';
import * as R from 'ramda';

type MultiStateSelector<S> = (key: string) => (state: Record<string, S>) => S;

export const createMultiStateSelector = <S>(stateSelector: Selector<S, Record<string, S>>): MultiStateSelector<S> =>
    // @ts-ignore
    // eslint-disable-next-line react-hooks/rules-of-hooks
    R.useWith(R.propOr({}), [R.identity, stateSelector]);
